module.exports = __webpack_public_path__ + "static/media/facebook-logo.d8a37c7c.svg";